module.exports = __webpack_public_path__ + "img/banner03.5f0d5566.png";